import { ApiMetaDataDTO, ErrorDTO } from 'declarations'
import { useMutation } from '@tanstack/react-query'
import { client } from 'services/helpers/apiConfig'
import { toast } from 'react-toastify'

export type UpdateParamsDTO = {
  status_id: string
  po_uuids: string[]
}

type ApiResponseDTO = {
  code: number
  data: any
  api_metadata: ApiMetaDataDTO
  message?: string
}

export const usePoBatchStatusUpdateMutation = () =>
  useMutation<unknown, ErrorDTO, UpdateParamsDTO>({
    mutationFn: async (values: UpdateParamsDTO) => {
      try {
        const res = await client.put<ApiResponseDTO>(
          '/po/status/update/batch',
          values
        )

        // toast.success('Supplier profile is updated')

        return res.data.data
      } catch (err) {
        toast.error(err.response.data.message)
        throw err.response.data
      }
    },
  })
